import {createAsyncThunk, createSlice, PayloadAction,UnknownAction} from "@reduxjs/toolkit";
import axios from 'axios';

import {RootState} from './rootReducer'
import {persistReducer} from "redux-persist";
import storageSession from 'redux-persist/lib/storage/session';
import {closeBackdrop, openBackdrop} from "./backdrop";
import {openNotifier} from "./notifier";
const apiUrl = process.env.REACT_APP_API_URL;

export interface IGuide{
    id:number,
    name:string
}
export interface ISchedule{
    id:number,
    timeHora:string
}


interface IGuideState {
    guide:IGuide
    schedules:ISchedule[],
    loadingGuide:boolean,
    loadingSchedule:boolean,
    loadingEdit:boolean,
    guides:IGuide[]
}

export const initialState: IGuideState = {
    guides:[],
    schedules:[],
    guide:{
        id:0,
        name:''
    },
    loadingEdit:false,
    loadingSchedule:false,
    loadingGuide:false
};

export const getSchedule = createAsyncThunk<ISchedule[],
    {},
    {
        rejectValue: unknown
    }>(
    'guide/getSchedule',
    async ({}, thunkApi) => {
        thunkApi.dispatch(openBackdrop())
        try {
            const response = await axios.get(`${apiUrl}/listSchedule`);
            // thunkApi.dispatch(openNotifier({open:true,variant:"success",message:``}))
            //list vehicles
            //thunkApi.dispatch(listVehicles({}))
            thunkApi.dispatch(closeBackdrop());
            return  response.data;
        } catch (err) {
            thunkApi.dispatch(closeBackdrop());

            // @ts-ignore
            // thunkApi.dispatch(openNotifier({open:true,variant:"error",message:err?.response?.data?.message??'Ha ocurrido un error y el sistema se ha tenido que cerrar'}))
            // @ts-ignore
            return thunkApi.rejectWithValue(err.response.data)
        }
    }
)

export const getGuides = createAsyncThunk<IGuide[],
    {},
    {
        rejectValue: unknown
    }>(
    'guide/getGuides',
    async ({}, thunkApi) => {
        thunkApi.dispatch(openBackdrop())
        try {
            const response = await axios.get(`${apiUrl}/listGuides`);
            // thunkApi.dispatch(openNotifier({open:true,variant:"success",message:``}))
            //list vehicles
            //thunkApi.dispatch(listVehicles({}))
            thunkApi.dispatch(closeBackdrop());
            return  response.data;
        } catch (err) {
            thunkApi.dispatch(closeBackdrop());

            // @ts-ignore
            // thunkApi.dispatch(openNotifier({open:true,variant:"error",message:err?.response?.data?.message??'Ha ocurrido un error y el sistema se ha tenido que cerrar'}))
            // @ts-ignore
            return thunkApi.rejectWithValue(err.response.data)
        }
    }
)





const guideSlice = createSlice({
    name: 'guide',
    initialState,
    extraReducers: builder => {
        builder
            .addCase(getGuides.pending, state => {
                state.loadingGuide = true
            })
            .addCase(getGuides.fulfilled, (state, {payload}) => {
                state.guides=payload
                state.loadingGuide = false
            })
            .addCase(getGuides.rejected, (state, action) => {
                state.loadingGuide = false
            })
            .addCase(getSchedule.pending, state => {
                state.loadingGuide = true
            })
            .addCase(getSchedule.fulfilled, (state, {payload}) => {
                state.schedules=payload
                state.loadingGuide = false
            })
            .addCase(getSchedule.rejected, (state, action) => {
                state.loadingGuide = false
            })
    },
    reducers: {
        resetGuide:(state)=>{
            state.guide=initialState.guide
        },

    },
});

export const {resetGuide} = guideSlice.actions

export const guideSelector = (state: RootState) => state.guide









export const GuideReducer = persistReducer({
    storage: storageSession,
    key: 'vehicle',
    whitelist: [''],
    blacklist:['']
}, guideSlice.reducer)
